import { sport } from 'constants/enum';

export const getIsThreeDigitsResultAvailable = sportId => [sport.basketball, sport.ebasketball].includes(sportId);

export const getThreeDigitsResultClassName = sportId => ([sport.basketball, sport.ebasketball].includes(sportId) ? 'three-digits-result-available' : '');
